export default __webpack_public_path__ + "static/media/image.af4b3c4a.png";